.articleHeader {
  font-family: var(--oc-font-family);
  font-size: 26px;
  font-weight: 800;
  line-height: 32px;
  text-align: left;
  padding: 16px 0;
}
@media (min-width: 728px) {
  .articleHeader {
    font-size: 28px;
    line-height: 36px;
  }
}
.articleDetailsContainer {
  display: flex;
  flex-direction: column;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--cxy-color-grey-200);
}
@media (min-width: 400px) {
  .articleDetailsContainer {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
}
.articleSummary {
  font-family: var(--oc-font-family);
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  text-align: left;
  padding-bottom: 16px;
}
.articleAuthor {
  font-family: var(--oc-font-family);
  font-size: 14px;
  font-weight: 400;
  line-height: normal;
  text-align: left;
  color: var(--cxy-color-midnight-blue-700);
  padding-bottom: 8px;
}
@media (min-width: 400px) {
  .articleAuthor {
    padding-bottom: 0;
  }
}
.articleHeroImage {
  aspect-ratio: 1028/355;
  position: relative;
  border-radius: 5px;
  overflow: hidden;
  display: inline-block;
  width: 100%;
}
.articleHeroImage img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
}
.articleMetadata {
  color: #6b7883;
  font-size: 12px;
}
.articleMetadata * {
  color: inherit;
  font-size: inherit;
}

.lockedContentIcon {
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  background-color: var(--cxy-color-interactive-primary);
  color: var(--cxy-color-black);
  font-family: var(--oc-font-family);
  font-size: 12px;
  font-weight: 600;
  padding: 2px;
  margin-top: -4px;
  cursor: pointer;
}
.lockedContentIcon:hover {
  background-color: var(--cxy-color-interactive-primary-hover);
}

.lockedContentButton {
  height: 14px;
  font-size: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  width: 100%;
}
